<template>
  <div class="product-content-item" :class="{ 'is-reverse': reverse }">
    <div class="product-content-item-container">
      <div class="text-block">
        <h3>{{ content.title }}</h3>
        <div
          class="text-block-label"
          v-for="(label, index) in content.labels"
          :key="label"
          @click="slideTo(index)"
        >
          <div v-html="label"></div>
        </div>
        <el-button type="primary" @click="toApply">立即体验</el-button>
      </div>
      <div class="img-block">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(img, index) in content.imgs" :key="index">
            <img :src="img" alt="" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductContentItem",
  props: {
    content: Object,
    reverse: Boolean,
  },
  data() {
    return {
      mySwiper: null,
      swiperOptions: {
        width: 620,
        height: 390,
        direction: "vertical",
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        // Some Swiper option/callback...
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  watch: {},
  methods: {
    toApply() {
      window.open("https://ctadmin.cingta.com/#/degreeform", "_black");
    },
    slideTo(index) {
      this.swiper.slideTo(index, 1000, false);
      setTimeout(() => {
        this.swiper.autoplay.start();
      }, 3000);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang='less'>
.product-content-item {
  background-color: #fff;
  &-container {
    display: flex;
    justify-content: space-between;
    height: 600px;
    width: 1180px;
    align-items: center;
    margin: 0 auto;
    .text-block {
      width: 496px;
      > h3 {
        margin: 0 0 30px;
        font-size: 28px;
        color: #141617;
        line-height: 34px;
        letter-spacing: 2px;
      }
      .text-block-label {
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 89px;
        margin-bottom: 20px;
        padding: 0 22px 0 18px;
        background: #f5f6f7;
        border-radius: 3px;
        border-left: 6px solid #1f57fc;
        font-size: 16px;
        line-height: 30px;
        letter-spacing: 2px;
        transition: all 0.3s ease;
        &:hover {
          transform: translateY(-10px);
          box-shadow: 0px 10px 30px 0px rgba(162, 183, 204, 0.1);
        }
      }
      .el-button {
        width: 142px;
        height: 42px;
        margin-top: 20px;
        background: #1f57fc;
        border-radius: 3px;
      }
    }
    .img-block {
      > .swiper-container {
        width: 620px;
        height: 390px;
        border-radius: 6px;
        overflow: hidden;
      }
      img {
        width: 620px;
        height: 390px;
      }
    }
  }
  &.is-reverse {
    background-color: #f5f6f7;
    .product-content-item-container {
      flex-direction: row-reverse;
      .text-block {
        .text-block-label {
          background-color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/productInfo/ProductContentItem.vue